const incrementTypes = {
  ORDER_ID: 'order_id',
  CO_ORDER_ID: 'co_order_id',
  CAR_ID: 'car_id',
  RETURN_ID: 'return_id',
  LISTING_ID: 'listing_id',
  CLIENT_ID: 'client_id',
  COUNT: 'count',
  CO_ORDER_PO_ID: 'co_order_po_id',
};

export default incrementTypes;
